import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryHover, brandPrimaryText, white } from '../../styles/colors';
import { CssSelectors, Fonts } from '../../styles/styles';
import TaggingGameButtonBackgroundImageUrl from './taggingGameButtonBackground.png';

export const styleSheet = StyleSheet.create({
	taggingGameLink: {
		alignItems: 'center',
		backgroundColor: white,
		backgroundImage: `url(${TaggingGameButtonBackgroundImageUrl})`,
		backgroundSize: '154px 69px',
		color: brandPrimaryText,
		display: 'flex',
		fontSize: 14,
		textDecoration: 'none',
		whiteSpace: 'nowrap',
		height: 36,
		padding: '0 10px',
		borderRadius: 8,
		border: `1px solid ${brandPrimary}`,
		fontFamily: Fonts.lexend,
		justifyContent: 'center',
		gap: '0.5rem',
		transition: 'color 0.25s ease, border 0.25s ease, underline 0.25s ease',
		':hover': {
			color: brandPrimaryHover,
			border: `1px solid ${brandPrimaryHover}`,
			textDecoration: 'underline',
		},
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
});
